"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImmediateActivity = createImmediateActivity;
exports.deleteImmediateActivity = deleteImmediateActivity;
exports.enableCloseImmediateActivity = enableCloseImmediateActivity;
exports.exportStationOrders = exportStationOrders;
exports.getGunList = getGunList;
exports.getImmediateActivityDetail = getImmediateActivityDetail;
exports.getImmediateActivityPage = getImmediateActivityPage;
exports.getIntegralLog = getIntegralLog;
exports.getStationList = getStationList;
exports.getStationOrderDetail = getStationOrderDetail;
exports.getStationOrderList = getStationOrderList;
exports.getSupplierList = getSupplierList;
exports.updateImmediateActivity = updateImmediateActivity;
exports.updateImmediateActivityStatus = updateImmediateActivityStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | 立减活动相关API接口
// +----------------------------------------------------------------------

/**
 * 立减活动分页列表
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页大小
 * @param {string} params.name 活动名称（搜索条件）
 * @param {number} params.page 页码
 * @param {number} params.status 活动状态（1:开始中 2:未开始 3:已结束）
 */
function getImmediateActivityPage(params) {
  return (0, _request.default)({
    url: '/admin/immediate-activity/page',
    method: 'get',
    params: params
  });
}

/**
 * 立减活动详情
 * @param {number} id 活动ID
 */
function getImmediateActivityDetail(id) {
  return (0, _request.default)({
    url: "/admin/immediate-activity/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 新增立减活动
 * @param {Object} data 活动数据
 */
function createImmediateActivity(data) {
  return (0, _request.default)({
    url: '/admin/immediate-activity/create',
    method: 'post',
    data: data
  });
}

/**
 * 更新立减活动
 * @param {number} id 活动ID
 * @param {Object} data 活动数据
 */
function updateImmediateActivity(id, data) {
  return (0, _request.default)({
    url: "/admin/immediate-activity/update",
    method: 'post',
    data: data
  });
}

/**
 * 删除立减活动
 * @param {number} id 活动ID
 */
function deleteImmediateActivity(id) {
  return (0, _request.default)({
    url: "/admin/immediate-activity/delete",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 更新立减活动状态
 * @param {number} id 活动ID
 * @param {number} status 状态值
 */
function updateImmediateActivityStatus(id, status) {
  return (0, _request.default)({
    url: "/admin/immediate-activity/update/status/".concat(id),
    method: 'post',
    data: {
      status: status
    }
  });
}

/**
 * 获取商家列表
 * @param {Object} params 查询参数
 */
function getSupplierList(params) {
  // return request({
  //   url: '/admin/business/supplier/autoList',
  //   method: 'get',
  //   params
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/supplier/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取油品类型列表
 * @param {Object} params 查询参数
 */
function getGunList(params) {
  return (0, _request.default)({
    url: '/admin/immediate-activity/getGunList',
    method: 'get',
    params: params
  });
}

/**
 * 获取加油站列表（立减活动）
 * @param {Object} params 查询参数
 */
function getStationList(params) {
  return (0, _request.default)({
    url: '/admin/immediate-activity/getStationList',
    method: 'get',
    params: params
  });
}

/**
 * 开启/关闭立减活动
 * @param {number} id 活动ID
 * @param {number} status 状态值
 */
function enableCloseImmediateActivity(id, status) {
  return (0, _request.default)({
    url: '/admin/immediate-activity/enable-close',
    method: 'get',
    params: {
      id: id,
      status: status
    }
  });
}

/**
 * 加油站订单列表
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页大小
 * @param {number} params.page 页码
 * @param {string} params.outTradeNo 商家订单号
 * @param {string} params.orderNo 交易订单号
 * @param {number} params.status 交易状态
 * @param {number} params.supplierId 商家ID
 * @param {string} params.phone 用户手机号
 * @param {string} params.startTime 开始时间
 * @param {string} params.endTime 结束时间
 */
function getStationOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/station/list',
    method: 'get',
    params: params
  });
}

/**
 * 加油站订单详情
 * @param {string} orderNo 订单号
 */
function getStationOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/station/detail/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 获取福豆使用记录列表
 * @param {string} orderNo 订单号
 */
function getIntegralLog(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/station/getIntegralLog/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 导出加油站订单
 * @param {Object} params 查询参数
 */
function exportStationOrders(params) {
  return (0, _request.default)({
    url: '/admin/order/station/export',
    method: 'get',
    params: params
    // responseType: 'blob'
  });
}